import { ObjectTyped } from '@price-for-profit/micro-services';
import { Brands } from 'shared/types';

export const BRANDS = {
  accuflow: 'Foodflow',
  cimtec: 'Cimtec',
  ffp: 'Bioflow',
  triangle: 'Triangle',
  accutech: 'Accutech',
  teamtechnical: 'Team Technical',
  ffpnorth: 'Fluid Flow Products North',
  texas: 'Texas',
  tulsa: 'Medflow',
  cbe: 'CB Process',
  lewis: 'Lewis',
  qualitystainless: 'Quality Stainless',
  indelco: 'Indelco',
  corrtech: 'Corr Tech',
  inscoprocess: 'Insco Process',
  nianticseal: 'Niantic Seal Inc.',
  newgen: 'New Gen',
  prestonphipps: 'Preston Phipps',
  sepump: 'SE Pump',
  shaltzautomation: 'Shaltz Automation',
  triphase: 'Tri Phase',
  rankin: 'Rankin',
  smithcameron: 'Smith Cameron',
} as const;

export const discountRecommendationBrands = ['corrtech', 'indelco'];
export const listPriceBrands: Brands[] = ['inscoprocess'];
export const lineItemNoteBrands: Brands[] = ['cimtec'];
export const brandsList = ObjectTyped.keys(BRANDS);
